var map = {
  "./messages_id.json": [
    "33733",
    "2534"
  ],
  "./messages_th.json": [
    "84032",
    "3737"
  ],
  "./messages_uk.json": [
    "50512",
    "7321"
  ],
  "./messages_it.json": [
    "6837",
    "4198"
  ],
  "./messages_en.json": [
    "1455",
    "8740"
  ],
  "./messages_es.json": [
    "31592",
    "6049"
  ],
  "./messages_sv.json": [
    "66293",
    "3334"
  ],
  "./messages_tr.json": [
    "60794",
    "4231"
  ],
  "./messages_hi.json": [
    "18767",
    "2068"
  ],
  "./messages_ru.json": [
    "23961",
    "9826"
  ],
  "./messages_de.json": [
    "10743",
    "8748"
  ],
  "./messages_ko.json": [
    "15210",
    "2567"
  ],
  "./messages_fr.json": [
    "91308",
    "1917"
  ],
  "./messages_fi.json": [
    "41953",
    "2042"
  ],
  "./messages_ja.json": [
    "72501",
    "1510"
  ],
  "./messages_cs.json": [
    "99094",
    "9915"
  ],
  "./messages_da.json": [
    "67339",
    "9464"
  ],
  "./messages_no.json": [
    "8691",
    "7040"
  ],
  "./messages_pt.json": [
    "92848",
    "9929"
  ],
  "./messages_vi.json": [
    "82033",
    "5978"
  ],
  "./messages_zh.json": [
    "71106",
    "4943"
  ],
  "./messages_nl.json": [
    "738",
    "7343"
  ],
  "./messages_pl.json": [
    "40088",
    "2113"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 65405;
module.exports = __rspack_async_context;
